import {NotificationsResource} from '@//common/api';
import {createEndpoint} from '@/logged/config';

export const notificationsEndpoints = () => ({
    notifications: createEndpoint<NotificationsResource>('notifications', {logger: false}),
});
